const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getTareasSinResponsable = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/sin-responsable`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas sin responsable.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas sin responsable:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Obtener usuarios por jefe (GET /api/admin/usuarios/por-jefe/{id})
export const getUsuariosPorJefe = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Extraer el ID del token
    const { jwtDecode } = await import('jwt-decode');
    const decodedToken = jwtDecode(token);
    const userId = decodedToken.userId;

    const response = await fetch(`${API_BASE_URL}admin/usuarios/por-jefe/${userId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener los usuarios por jefe.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener los usuarios por jefe:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Asignar responsable a una tarea (PUT /api/tareas/{tareaId}/asignar)
export const asignarResponsableTarea = async (tareaId, usuarioResponsableId) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/asignar`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        usuarioResponsableId: usuarioResponsableId
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al asignar responsable a la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al asignar responsable a la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};